export * from "-!../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../node_modules/vue-style-loader/index.js!../../node_modules/css-loader/index.js??ref--6-2!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/lib/index.js??ref--6-3!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Invitations.vue?vue&type=style&index=0&id=41749d6c&prod&lang=css"


//////////////////
// WEBPACK FOOTER
// ./src/views/Invitations.vue?vue&type=style&index=0&id=41749d6c&prod&lang=css
// module id = X1oO
// module chunks = 1